import { requiresConnorsApplyConfirm } from "./connorsApplyCompany";
import { shouldSkipConnorsApplyPopup } from "./connorsStorage";

export function getJobCompanyName(job) {
  if (!job) {
    return "";
  }

  if (Array.isArray(job)) {
    const match = job.find((item) =>
      requiresConnorsApplyConfirm(item?.company?.name || item?.companyName)
    );
    return match?.company?.name || match?.companyName || "";
  }

  return job?.company?.name || job?.companyName || job?.name || "";
}

export function needsConnorsApplyConfirm(entity) {
  if (shouldSkipConnorsApplyPopup()) {
    return false;
  }

  return requiresConnorsApplyConfirm(getJobCompanyName(entity));
}
